var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4677 17.914C19.4982 16.615 18.1695 15.632 16.6255 15.0352C15.1533 16.4395 13.1783 17.3171 11.0238 17.3171C8.86932 17.3171 6.93028 16.4746 5.45805 15.0352C2.26222 16.2288 0 19.2832 0 22.8641V25.778C0 26.2695 0.39499 26.6557 0.897705 26.6557H14.6505C14.6505 26.5153 14.6505 26.3398 14.6505 26.1642C14.6505 22.4077 17.0564 19.1778 20.4677 17.914Z",
    fill: "url(#paint0_linear_6779_9936)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51218 8.79372C4.51218 12.5853 7.42075 15.6748 11.0116 15.6748C14.6024 15.6748 17.5109 12.5853 17.5109 8.79372C17.5109 8.44265 17.5109 8.05647 17.475 7.70539C18.5164 4.72126 18.0137 -0.755509 16.0028 0.08707C14.2792 0.824327 4.79945 -1.52787 5.33807 2.36906C3.11176 2.43927 4.26083 6.72238 4.51218 7.67028C4.51218 8.05647 4.51218 8.44265 4.51218 8.79372ZM6.48713 9.00437C6.73849 9.00437 6.91803 8.82883 6.88212 8.58308C6.7744 7.56496 6.55895 5.00212 7.45665 5.21276C8.60572 5.49362 9.8625 5.8447 10.9757 5.8447C12.0888 5.8447 13.3456 5.52873 14.4947 5.21276C15.3924 4.96701 15.2128 7.56496 15.0692 8.58308C15.0333 8.82883 15.2487 9.00437 15.4642 9.00437L15.8592 8.96926C15.7874 11.813 13.597 14.1301 10.9757 14.1301C8.31845 14.1301 6.16396 11.8481 6.09214 8.96926L6.48713 9.00437Z",
    fill: "url(#paint1_linear_6779_9936)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6988 19.0742C19.6771 19.0742 16.4453 22.269 16.4453 26.1659C16.4453 30.098 19.713 33.2576 23.6988 33.2576C27.7205 33.2576 30.9522 30.0629 30.9522 26.1659C30.9522 22.269 27.6846 19.0742 23.6988 19.0742ZM18.7793 23.6733C19.713 21.953 21.5443 20.7594 23.6988 20.7594C25.8174 20.7594 27.6846 21.953 28.6182 23.6733C28.8336 24.0946 28.5464 24.6212 28.0437 24.5861C27.6846 24.551 27.3255 24.551 26.9664 24.5159C26.6073 24.5159 26.3201 24.3403 26.0687 24.0946C25.5301 23.4978 24.6683 23.1116 23.6988 23.1116C22.7292 23.1116 21.9034 23.4978 21.3288 24.0946C21.1134 24.3403 20.7902 24.5159 20.4311 24.5159C20.072 24.5159 19.713 24.551 19.3539 24.5861C18.8871 24.5861 18.5639 24.0946 18.7793 23.6733ZM21.1493 31.0108C19.7848 30.3437 18.7793 29.115 18.3484 27.6756C18.2048 27.1489 18.7075 26.6925 19.2462 26.8681C20.7543 27.3596 21.8315 28.5883 22.1188 30.098L22.1547 30.2735C22.2624 30.8352 21.6879 31.2565 21.1493 31.0108ZM23.6988 27.6053C22.9806 27.6053 22.442 27.0436 22.442 26.3766C22.442 25.6744 23.0165 25.1478 23.6988 25.1478C24.4169 25.1478 24.9556 25.7095 24.9556 26.3766C24.9556 27.0787 24.381 27.6053 23.6988 27.6053ZM26.2123 31.0108C25.7096 31.2565 25.0992 30.8352 25.2069 30.2735L25.2428 30.098C25.5301 28.5883 26.6432 27.3596 28.1155 26.8681C28.6182 26.6925 29.1568 27.1489 29.0132 27.6756C28.6182 29.115 27.5769 30.3437 26.2123 31.0108Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6779_9936",
    x1: 10.2338,
    y1: 15.0352,
    x2: 10.2338,
    y2: 26.6557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B8AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6779_9936",
    x1: 10.9977,
    y1: 0,
    x2: 10.9977,
    y2: 15.6748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B8AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/Driver.4ef3cd20c9367648a9dbd903732eea1c.svg";
export { ForwardRef as ReactComponent };